import React from 'react';
import BasketSelect from './BasketSelect';
import type { TimecardReportStatusFilter } from '../utils/timecardReportFilters';

interface TimecardReportFiltersPanelProps {
  statusFilter: TimecardReportStatusFilter;
  onStatusFilterChange: (value: TimecardReportStatusFilter) => void;
  employees: { id: number; label: string }[];
  schedules: { id: number; label: string }[];
  positions: { id: number; label: string }[];
  selectedEmployeeIds: number[];
  onEmployeeIdsChange: (ids: number[]) => void;
  selectedScheduleIds: number[];
  onScheduleIdsChange: (ids: number[]) => void;
  selectedPositionIds: number[];
  onPositionIdsChange: (ids: number[]) => void;
  loadingOptions?: boolean;
}

const TimecardReportFiltersPanel: React.FC<TimecardReportFiltersPanelProps> = ({
  statusFilter,
  onStatusFilterChange,
  employees,
  schedules,
  positions,
  selectedEmployeeIds,
  onEmployeeIdsChange,
  selectedScheduleIds,
  onScheduleIdsChange,
  selectedPositionIds,
  onPositionIdsChange,
  loadingOptions,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-neutral-700 mb-2">Timecard status</label>
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value as TimecardReportStatusFilter)}
          className="w-full max-w-xs px-3 py-2 border border-neutral-300 rounded-md text-sm bg-white"
        >
          <option value="all">All</option>
          <option value="approved">Approved</option>
          <option value="unapproved">UnApproved</option>
        </select>
      </div>

      <BasketSelect
        label="Schedule"
        availableItems={schedules}
        selectedIds={selectedScheduleIds}
        onChange={(ids) => onScheduleIdsChange(ids as number[])}
        placeholder="All schedules (optional)"
      />
      <BasketSelect
        label="Position"
        availableItems={positions}
        selectedIds={selectedPositionIds}
        onChange={(ids) => onPositionIdsChange(ids as number[])}
        placeholder="All positions (optional)"
      />
      <BasketSelect
        label="Employee"
        availableItems={employees}
        selectedIds={selectedEmployeeIds}
        onChange={(ids) => onEmployeeIdsChange(ids as number[])}
        placeholder="All employees (optional)"
      />

      {loadingOptions && (
        <p className="text-xs text-neutral-500">Loading filter options…</p>
      )}
    </div>
  );
};

export default TimecardReportFiltersPanel;
